<template>
  <div class="container" v-if="set">
    <part-box
      v-for="part in sortedParts"
      :part="part"
      :key="part.id + '-' + part.color.id"
      @click.native="clickPart(part.id + '-' + part.color.id)"
    ></part-box>
  </div>
</template>



<script>
import partBox from "@/components/part-box.vue";

export default {
  name: "parts",

  data() {
    return {};
  },
  props: {
    set: Object,
    sort: String,
    search: String
  },
  components: {
    partBox
  },
  computed: {
    sortedParts() {
      console.log("Part Compute");
      if (this.sort); // Make sort a reactive dependency
      return Object.values(this.set.parts)
        .map(part => {
          let filter = !(
            this.search == null ||
            [part.part.name, part.color.name].some(
              x =>
                String(x)
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) !== -1
            )
          );
          return { ...part, filter };
        })
        .sort((a, b) => {
          return a.filter == b.filter ? a.sort - b.sort : a.filter - b.filter;
        });
    }
  },
  methods: {
    clickPart(id) {
      this.$parent.menuBlur();
      let set = this.$route.params.set;
      let part = set.parts[id];

      if (this.$root.$UserRef) {
        if (part.found < part.quantity) {
          this.$root.$UserRef
            .child("sets/" + set + "/parts/" + id + "/found")
            .transaction(function(current_value) {
              return (current_value || 0) + 1;
            });
        } else {
          var resp = prompt(
            "Reset to what value? (less than " + part.quantity + ")"
          );
          if (resp !== null) {
            resp = parseInt(resp);
            if (resp >= 0 && resp <= part.quantity) {
              this.$root.sets[set].found += resp - part.quantity;
              this.$root.$UserRef
                .child("sets/" + set + "/parts/" + id + "/found")
                .set(resp);
            } else {
              alert(
                "Invalid input, must be a number from 0 to " + part.quantity
              );
            }
          }
        }
      } else {
        console.log("No Ref");
      }
    },
    sortParts() {
      let parts = Object.values(this.set.parts); // Pass by reference
      // Sort values
      switch (this.sort) {
        case "name":
          parts.sort((a, b) => {
            return a.part.name.localeCompare(b.part.name);
          });
          break;
        case "missing":
          parts.sort((a, b) => {
            return b.quantity - b.found - a.quantity + a.found;
          });
          break;
        case "category":
          parts.sort((a, b) => {
            return b.quantity - b.found - a.quantity + a.found;
          });
          break;
        case "color":
          parts.sort((a, b) => {
            return b.quantity - b.found - a.quantity + a.found;
          });
          break;
        case "completeness":
          parts.sort((a, b) => {
            return b.completeness - a.completeness;
          });
          break;
        case "incompleteness":
          parts.sort((a, b) => {
            return a.completeness - b.completeness;
          });
          break;
      }
      // Apply Sort values
      parts.forEach((part, i) => {
        part.sort = i;
      });
    }
  },
  watch: {
    sort(n, o) {
      // Sort on sort change
      if (n) this.sortParts();
    },
    set(n, o) {
      // Sort once set is avaliable
      if (o == null) this.sortParts();
    }
  },
  created() {
    if (this.set) this.sortParts();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
}
</style>



// WEBPACK FOOTER //
// src/components/parts.vue